export default "__VITE_ASSET__DcJR$jKZ__"